import React, { JSX, ReactNode, useState } from 'react';
import Icons from 'components/atoms/Icons';

type SidebarProps<T extends ReactNode> = {
  header: string;
  pageType: string;
  children: T;
  customHeader?: string;
  hideLocationHeader?: boolean;
};

const Sidebar = <T extends ReactNode>({
  header,
  pageType,
  children,
  customHeader,
  hideLocationHeader = false,
}: SidebarProps<T>): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="sidebar-container" id="sidebar-container">
      <div
        className={`${isOpen ? 'sidebar open' : 'sidebar'} ${
          pageType == 'provider' ? 'provider' : 'location'
        }`}
      >
        {pageType == 'provider' ? (
          <h3
            className={`header ${customHeader ? customHeader : ''}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            {header}
            {isOpen ? <Icons id="chevron-down" /> : <Icons id="chevron-up" />}
          </h3>
        ) : (
          <h2
            className={`header ${
              hideLocationHeader
                ? 'visually-hidden'
                : customHeader
                  ? customHeader
                  : ''
            }`}
            onClick={() => setIsOpen(!isOpen)}
          >
            {hideLocationHeader
              ? 'Contact Information'
              : header}

            {!hideLocationHeader &&
              (isOpen ? (
                <Icons id="chevron-down" />
              ) : (
                <Icons id="chevron-up" />
              ))}
          </h2>
        )}
        <div className="sidebar-content-wrapper">
          <div className="sidebar-content">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
